import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const CareerPage = () => {
   
useEffect(() => {
        const link = document.createElement("link");
        link.href = "https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css";
        link.rel = "stylesheet";
        link.id = "tailwind-mutualfund"; // Add ID so you can remove it later if needed
        document.head.appendChild(link);
    
        return () => {
          // Optional: Clean up when component unmounts
          document.getElementById("tailwind-mutualfund")?.remove();
        };
      }, []);
    return (
        <>
        {/* <!-- Hero Section --> */}
  <section className="bg-blue-50 py-20 text-center">
    <h1 className="text-4xl font-bold text-blue-900 mb-4">Join Our Mission at GPS Finvest</h1>
    <p className="text-lg text-gray-700 mb-6 max-w-3xl mx-auto">Be a part of a dynamic team shaping the future of investment and financial inclusion in India.</p>
    <div ><a className="btn btn-primary" href="https://gpsfinvest.investwell.app/app/#/login">View Openings</a></div>
  </section>

  {/* <!-- Why Work With GPS Finvest --> */}
  <section className="py-16 bg-white text-center">
    <div className="max-w-5xl mx-auto px-4">
      <h2 className="text-3xl font-bold text-green-700 mb-10">Why Work With GPS Finvest?</h2>
      <div className="grid md:grid-cols-3 gap-8 text-left">
        <div className="bg-blue-50 p-6 rounded shadow hover:shadow-lg transition duration-300">
          <h3 className="text-xl font-semibold text-blue-800 mb-2">🌍 Impact-Driven Culture</h3>
          <p>Contribute to democratizing finance and empowering retail investors across India.</p>
        </div>
        <div className="bg-blue-50 p-6 rounded shadow hover:shadow-lg transition duration-300">
          <h3 className="text-xl font-semibold text-blue-800 mb-2">🚀 Growth Opportunities</h3>
          <p>Work with financial experts and expand your career in wealth management and fintech.</p>
        </div>
        <div className="bg-blue-50 p-6 rounded shadow hover:shadow-lg transition duration-300">
          <h3 className="text-xl font-semibold text-blue-800 mb-2">🤝 Collaborative Environment</h3>
          <p>Thrive in a team-first culture where innovation, integrity, and curiosity are celebrated.</p>
        </div>
      </div>
    </div>
  </section>

  {/* <!-- Additional Perks Section --> */}
  <section className="py-16 bg-blue-50 text-center">
    <div className="max-w-5xl mx-auto px-4">
      <h2 className="text-3xl font-bold text-blue-900 mb-10">Perks of Being With Us</h2>
      <div className="grid md:grid-cols-3 gap-8 text-left">
        <div className="bg-white p-6 rounded shadow hover:shadow-lg transition duration-300">
          <h3 className="text-xl font-semibold text-green-700 mb-2">🧘‍♂️ Work-Life Balance</h3>
          <p>Enjoy flexibility that supports your well-being, both professionally and personally.</p>
        </div>
        <div className="bg-white p-6 rounded shadow hover:shadow-lg transition duration-300">
          <h3 className="text-xl font-semibold text-green-700 mb-2">📚 Continuous Learning</h3>
          <p>Access to courses, workshops, and mentorship to help you grow in your field.</p>
        </div>
        <div className="bg-white p-6 rounded shadow hover:shadow-lg transition duration-300">
          <h3 className="text-xl font-semibold text-green-700 mb-2">💼 Meaningful Work</h3>
          <p>Be part of initiatives that directly impact how India saves, invests, and grows wealth.</p>
        </div>
      </div>
    </div>
  </section>

  {/* <!-- Call to Action --> */}
  <section className="py-16 bg-white text-center">
    <div className="max-w-3xl mx-auto px-4">
      <p className="text-lg text-gray-700 mb-8">Ready to take the next step in your career?</p>
      <div ><a className="btn btn-primary" href="mailto:careers@gpsfinvest.com"> <i className="fa-solid fa-envelope"></i> Send Your Resume</a></div>
    </div>
  </section>
        </>
    );
};

export default CareerPage;
